import React from 'react';

function HeroAbout() {
    return (
        <>
            <div className="appie-about-top-title-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="appie-about-top-title">
                                <p>SOMOS LIDERES EN LA DISTRIBUCIÓN Y COMERCIALIZACIÓN DE</p>
                                <h2 style={{fontSize:50}} className="title">PRODUCTOS ÉTNICOS</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="appie-about-page-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="appie-about-page-contentquienes">
                             
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default HeroAbout;
